import React, { useRef } from 'react'
import { motion, useScroll, useTransform, useSpring, useReducedMotion, useInView } from 'framer-motion'

const AnimatedElement = (props) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const options = props.options && props.options !== null ? props.options : null
  const prefersReducedMotion = useReducedMotion()

  const scrollOffset = options !== null && options.offset ? options.offset : ['-100vh', '-70vh']
  const scrollTranslate = options !== null && options.translate ? options.translate : [200, 0]

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: [scrollOffset[0], scrollOffset[1]]
  })
  const translateY = useSpring(scrollYProgress, {
    stiffness: 50,
    damping: 30
  })
  const translateX = useSpring(scrollYProgress, {
    stiffness: 50,
    damping: 30
  })

  const translateDirection = options !== null && options.direction && options.direction === 'x' ? translateX : translateY
  const contentAnim = useTransform(translateDirection, [0, 1], [scrollTranslate[0], scrollTranslate[1]])

  return (
    <div 
      ref={ref} 
      className="w-full h-full"
    >
      {options !== null ? (
        <motion.div
          style={options.direction && options.direction === 'x' ? ({
            x: (!prefersReducedMotion && isInView) && contentAnim
          }) : ({
            y: (!prefersReducedMotion && isInView) && contentAnim
          })}
          className={props.className ? props.className : ''}
        >
          {props.children}
        </motion.div>
      ) : (
        <div className={props.className ? props.className : ''}>
          {props.children}
        </div>
      )}
    </div>
  )
}

export default AnimatedElement
